export default "/Frontend/dist/event-background3-grey.0dbed48825df42bbba51a7e3672af12d.svg";